module.exports = __webpack_public_path__ + "static/media/img-default.5c8eece6.png";